

export const PropertyInput = ({ onAddProp, propValue, propCaption, onChangeCaption, onChangeValue }) => {
    return (
        <div className="add-property-box">
            <div className="input-group-box">
                <input 
                    type="text" 
                    className="prop-name prop-input"
                    placeholder="Property e.g. RAM"
                    value={propCaption}
                    onChange={(e) => onChangeCaption(e)}
                />
                <input 
                    type="text" 
                    className="prop-value prop-input"
                    placeholder="Description e.g. 128 Mb"
                    value={propValue}
                    onChange={(e) => onChangeValue(e)}
                />
            </div>
            <div className="add-prop-bttn-box">
                <button className="add-prop-bttn" onClick={onAddProp}>Add</button>
            </div>
        </div>
    )
}